export default __webpack_public_path__ + "static/O0218-bf86cca004b9a4675ecfa656f594f359.png";